import DOMPurify from 'dompurify';

// Resource links are meant to open in a new tab so a user does not lose their
// report, but target is not on DOMPurify's default allow-list. Keep it, and
// pair every new-tab link with rel="noopener noreferrer" so the opened page
// cannot reach back through window.opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * Prepares server-supplied HTML for dangerouslySetInnerHTML.
 *
 * Descriptions, instructions, report messages, resources and FAQ answers are
 * all rich text typed into the CMS, so they have to render as HTML. Passing
 * them straight through meant whoever can edit that content could also run
 * script in a user's browser. Sanitizing keeps the formatting and drops
 * anything executable.
 *
 * Use as: dangerouslySetInnerHTML={safeHtml(value)}
 */
function safeHtml(html) {
  return {
    __html: DOMPurify.sanitize(html == null ? '' : String(html), { ADD_ATTR: ['target'] }),
  };
}

export default safeHtml;
